<template>
  <div class="container">

    <div class="topBox">
      <h1>套餐管理</h1>
      <el-button type="primary" @click="onClickAddNewData()">添加套餐</el-button>
    </div>

    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="imageList" label="图片" width="150">
        <template #default="{ row }">
          <div class="imgBox">
            <img v-if="row.imageList && row.imageList.length > 0" :src="row.imageList[0].url" alt="图片" />
            <span v-if="row.imageList">*{{ row.imageList.length }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="nameZh" label="标题" width="300" />
      <el-table-column prop="price" label="价格" width="100">
        <template #default="{ row }">
          ¥{{ row.price }}
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="修改时间" width="200" />

      <el-table-column fixed="right" label="操作" min-width="120">
        <template #default="{ row }">
          <el-button link type="primary" size="small" @click="handleEdit(row)">
            编辑
          </el-button>
          <el-button link type="danger" size="small" @click="handleShowDeleteDialog(row)">
            删除
          </el-button>
        </template>
      </el-table-column>

    </el-table>



    <el-dialog v-model="dialogFormVisible" title="编辑套餐" width="800">
      <el-form :model="currentCarData" ref="ruleFormRef" :rules="rules">

        <el-form :model="currentCarData" ref="ruleFormRef" :rules="rules">

          <el-row>
            <el-col :span="24">
              <el-form-item label="相关图片" prop="WeddingImages">
                <div class="avatar-container">
                  <div class="avatar-box" v-for="(item, index) in imageArray" :key="item.id">
                    <el-image class="avatar" :src="item.url" fit="cover" />

                    <Delete class="delete-icon" style="width: 1em; height: 1em;" @click="removeImage1(index)" />

                  </div>

                  <el-upload v-if="imageArray.length < 7" ref="upload" class="upload-demo" :limit="1"
                    :before-upload="beforeUpload" :show-file-list="false">

                    <div class="avatar-box">
                      <FolderAdd class="uploader-icon" style="width: 1em; height: 1em;" />
                    </div>

                  </el-upload>


                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="维语套餐名称" prop="name">
                <el-input v-model="currentCarData.name" autocomplete="off" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="中文套餐名称" prop="nameZh">
                <el-input v-model="currentCarData.nameZh" autocomplete="off" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="套餐价格" prop="price">
                <el-input v-model="currentCarData.price" type="number" min="0" required></el-input>
              </el-form-item>
            </el-col>

            <el-col class="dialog-el" :span="12">
              <el-form-item label="几年经验" prop="mouldingNum">
                <el-select v-model="currentCarData.yearNum" placeholder="请选择">
                  <el-option v-for="num in 20" :key="num" :label="num" :value="num"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col class="dialog-el" :span="24">
              <el-form-item label="维语简介" prop="description">
                <el-input v-model="currentCarData.description" type="textarea" :rows="4"
                  @change="handleDescriptionChange"></el-input>
              </el-form-item>
            </el-col>
            <el-col class="dialog-el" :span="24">
              <el-form-item label="中文简介" prop="descriptionZh">
                <el-input v-model="currentCarData.descriptionZh" type="textarea" :rows="4"
                  @change="handleDescriptionZhChange"></el-input>
              </el-form-item>
            </el-col>
            <el-col class="dialog-el" :span="24">
              <el-form-item label="维语服务内容" prop="serviceContent">
                <el-input v-model="currentCarData.serviceContent" type="textarea" :rows="4"
                  @change="handleServiceContentChange"></el-input>
              </el-form-item>
            </el-col>
            <el-col class="dialog-el" :span="24">
              <el-form-item label="中文服务内容" prop="serviceContentZh">
                <el-input v-model="currentCarData.serviceContentZh" type="textarea" :rows="4"
                  @change="handleServiceContentZhChange"></el-input>
              </el-form-item>
            </el-col>
            <el-col class="dialog-el" :span="24">
              <el-form-item label="维语出城费用说明" prop="leaveCityDescription">
                <el-input v-model="currentCarData.leaveCityDescription" type="textarea" :rows="4"
                  @change="handleLeaveCityDescriptionChange"></el-input>
              </el-form-item>
            </el-col>
            <el-col class="dialog-el" :span="24">
              <el-form-item label="中文出城费用说明" prop="leaveCityDescriptionZh">
                <el-input v-model="currentCarData.leaveCityDescriptionZh" type="textarea" :rows="4"
                  @change="handleLeaveCityDescriptionZhChange"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>

      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="success" @click="dialogMuBan = true">查看实例模板</el-button>
          <el-button @click="dialogFormVisible = false">取消</el-button>
          <el-button type="primary" @click="onClickAddData(ruleFormRef)">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog v-model="dialogVisible" title="提示" width="300" :before-close="handleClose">
      <span>删除后无法恢复，确定要删除么？</span>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleDelete()">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog v-model="dialogMuBan" title="乐队套餐模板" width="600">

      <el-row :gutter="20">
        <el-col :span="12">
          <h4>参考模板</h4>

          <div style="border: 2px solid grey; border-radius: 8px;height: 600px;overflow-y: auto;">

            <el-carousel height="250px">
              <el-carousel-item>
                <el-image style="width: 100%; height: 250px"
                  src="https://nimg.ws.126.net/?url=http%3A%2F%2Fdingyue.ws.126.net%2F2024%2F0716%2Fe2227946j00sgowu5003yd200sg00neg00sg00ne.jpg&thumbnail=660x2147483647&quality=80&type=jpg"
                  fit="cover" />
              </el-carousel-item>
              <el-carousel-item>
                <el-image style="width: 100%; height: 250px" src="https://img95.699pic.com/xsj/02/m9/ps.jpg%21/fh/300"
                  fit="cover" />
              </el-carousel-item>
              <el-carousel-item>
                <el-image style="width: 100%; height: 250px"
                  src="https://img0.baidu.com/it/u=3930982629,1442527811&fm=253&fmt=auto&app=138&f=JPEG?w=550&h=367"
                  fit="cover" />
              </el-carousel-item>
            </el-carousel>

            <div style="display: flex;margin: 10px 10px;align-items: center;">
              <span style="font-size: 14px;color: red;">￥5000</span>
              <span style="font-size: 12px; margin-left: 10px;
                 background-color: #f5f5f5; 
                 border-radius: 4px;        
                 padding: 2px 8px;        
                 display: inline-block;">5年经验</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: center;">
              <div style=" background-color: #f5f5f5; 
                 border-radius: 4px;width: 4px;height: 15px;background-color: red;"></div>
              <span style="font-size: 14px;font-weight: bold; margin-left: 5px;">简介</span>
            </div>

            <span style="font-size: 12px;color: black;margin: 10px 10px; text-align: left; 
              display: block;">音乐风格： 流行/电子等<br>
              成立时间： 2015 <br>
              成员组成：主持人、主唱、吉他手、贝斯手、鼓手等 <br>
              沙漠之声乐队 <br>
              是一支来自新疆/乌鲁木齐的本土音乐风格乐队，以独特的音乐特点，强烈的节奏感/细腻的旋律创作/实验性编曲等著称。自成立以来，乐队始终坚持音乐理念，原创精神/情感表达/社会观察等，在新疆/某音乐圈积累了稳定的乐迷群体。
            </span>

            <div style="display: flex;margin: 10px 10px;align-items: center;">
              <div style=" background-color: #f5f5f5; 
                 border-radius: 4px;width: 4px;height: 15px;background-color: red;"></div>
              <span style="font-size: 14px;font-weight: bold; margin-left: 5px;">服务内容</span>
            </div>

            <span style="font-size: 12px;color: black;margin: 10px 10px; text-align: left; 
              display: block;">
              1. 乐队演出 <br>
              定制化表演：根据婚礼主题，提供流行、民族或融合风格的音乐演出<br>
              暖场互动：乐队现场演奏，活跃婚礼氛围，带动宾客参与<br>
              新人专属曲目：可提前定制新人喜欢的歌曲，在仪式或晚宴环节演奏<br>
              <br>
              2. 专业主持人 <br>
              双语主持（汉语/维吾尔语可选），确保现场沟通流畅<br>
              仪式流程把控：从迎宾、入场、宣誓到敬酒环节，全程专业引导<br>
              互动游戏设计：安排趣味游戏，调动宾客热情，避免冷场<br>
              <br>
              3. 婚礼流程协调 <br>
              时间规划：合理安排乐队表演、主持环节与宴会时间<br>
              设备支持：提供音响、麦克风等基础设备（如需专业灯光、舞台可额外安排）<br>
              民族文化融合：可结合新疆传统音乐与舞蹈，打造特色婚礼体验<br>
              <br>
              4. 可选增值服务 <br>
              即兴表演：乐队与主持人配合，为新人献上惊喜环节<br>
              婚礼音乐编排：从入场BGM到退场曲目，全程定制歌单<br>
              后期纪念视频：提供婚礼精彩片段剪辑（含乐队演出花絮）<br>
              备注：服务内容可根据新人需求灵活调整，支持个性化定制！<br>
            </span>
            <div style="display: flex;margin: 10px 10px;align-items: center;">
              <div style=" background-color: #f5f5f5; 
                 border-radius: 4px;width: 4px;height: 15px;background-color: red;"></div>
              <span style="font-size: 14px;font-weight: bold; margin-left: 5px;">出城费用</span>
            </div>
            <span style="font-size: 12px;color: black;margin: 10px 10px; text-align: left; 
              display: block;">
              基准地点：乌鲁木齐<br>
              周边地区（车程≤2小时，如昌吉、吐鲁番等）<br>
              基础费用：+¥800-¥1500（含团队往返交通）<br>
              北疆城市（如伊宁、阿勒泰等）<br>
              基础费用：+¥3000-¥5000（含交通+1晚住宿）<br>
              南疆城市（如喀什、和田等）<br>
              基础费用：+¥4000-¥6000（含交通+1晚住宿）<br>
              <br>
              注：<br>
              具体费用根据活动时间、人数及设备需求调整<br>
              偏远地区需另议（如塔县、可可托海等）<br>
              长期合作可享折扣<br>
              <br>
              示例报价<br>
              昌吉婚礼：乌鲁木齐价+¥1000<br>
              喀什商演：乌鲁木齐价+¥5500<br>
            </span>
          </div>

        </el-col>
        <el-col :span="12">
          <h4>您编辑的</h4>
          <div style="border: 2px solid grey; border-radius: 8px;height: 600px;overflow-y: auto;">
            <el-carousel height="250px">
              <el-carousel-item v-for="(image, index) in currentCarData.imageList" :key="index">
                <el-image style="width: 100%; height: 250px" :src="image.url" fit="cover" />
              </el-carousel-item>
            </el-carousel>

            <div style="display: flex;margin: 10px 10px;align-items: center;">
              <span style="font-size: 14px;color: red;">￥{{ currentCarData.price }}</span>
              <span style="font-size: 12px; margin-left: 10px;
                 background-color: #f5f5f5; 
                 border-radius: 4px;        
                 padding: 2px 8px;        
                 display: inline-block;">{{ currentCarData.yearNum }}年经验</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: center;">
              <div style=" background-color: #f5f5f5; 
                 border-radius: 4px;width: 4px;height: 15px;background-color: red;"></div>
              <span style="font-size: 14px;font-weight: bold; margin-left: 5px;">简介</span>
            </div>

            <span style="font-size: 12px;color: black;margin: 10px 10px; text-align: left; 
              display: block;">
              {{ currentCarData.descriptionZh }}
            </span>

            <div style="display: flex;margin: 10px 10px;align-items: center;">
              <div style=" background-color: #f5f5f5; 
                 border-radius: 4px;width: 4px;height: 15px;background-color: red;"></div>
              <span style="font-size: 14px;font-weight: bold; margin-left: 5px;">服务内容</span>
            </div>

            <span style="font-size: 12px;color: black;margin: 10px 10px; text-align: left; 
              display: block;">
              {{ currentCarData.serviceContentZh }}
            </span>
            <div style="display: flex;margin: 10px 10px;align-items: center;">
              <div style=" background-color: #f5f5f5; 
                 border-radius: 4px;width: 4px;height: 15px;background-color: red;"></div>
              <span style="font-size: 14px;font-weight: bold; margin-left: 5px;">出城费用</span>
            </div>
            <span style="font-size: 12px;color: black;margin: 10px 10px; text-align: left; 
              display: block;">
              {{ currentCarData.leaveCityDescriptionZh }}
            </span>

          </div>

        </el-col>
      </el-row>

    </el-dialog>

  </div>
</template>

<script>
import { ref, computed, onMounted, reactive } from 'vue'
import { ElMessage } from 'element-plus'
import { get, upload, post } from '@/api/http';
import { useStore } from 'vuex';


export default {
  name: 'EmceePage',
  setup() {
    const store = useStore();

    const tableData = ref([]);
    const currentCarData = ref(null);
    const dialogFormVisible = ref(false);
    const imageArray = ref([]);
    const ruleFormRef = ref(null);
    const dialogVisible = ref(false);
    const dialogMuBan = ref(false);



    const shopId = computed(() => {
      const shop = store.state.shop;
      return shop ? shop.id : '';
    });


    // 表单验证规则
    const rules = reactive({
      WeddingImages: [
        {
          validator: (rule, value, callback) => {

            if (imageArray.value.length <= 0) {
              callback(new Error('图片不能为空'));
            } else {
              callback();
            }

          },
          trigger: 'change'
        }
      ],

      name: [{ required: true, message: '请输入维语名称', trigger: 'blur' }],
      nameZh: [{ required: true, message: '请输入中文名称', trigger: 'blur' }],
      price: [{ required: true, message: '请输入价格', trigger: 'blur' }, {
        validator: (rule, value, callback) => {
          if (value < 0) {
            callback(new Error('价格不能为负数'));
          } else {
            callback();
          }
        },
        trigger: 'blur'
      }],
      description: [{ required: true, message: '请输入维语简介', trigger: 'blur' }],
      descriptionZh: [{ required: true, message: '请输入中文简介', trigger: 'blur' }],
      serviceContent: [{ required: true, message: '请输入维语服务内容', trigger: 'blur' }],
      serviceContentZh: [{ required: true, message: '请输入中文服务内容', trigger: 'blur' }],
      leaveCityDescription: [{ required: true, message: '请输入维语出城费用说明', trigger: 'blur' }],
      leaveCityDescriptionZh: [{ required: true, message: '请输入中文出城费用说明', trigger: 'blur' }],
      yearNum: [{ required: true, message: '请选择经验年份', trigger: 'change' }],

    });


    onMounted(() => {
      getData();
    });


    const getData = async () => {
      try {
        const response = await get('adminWeddingEmcee/allEmcee', { "shopId": shopId.value })
        if (response.code === 200) {
          tableData.value = response.data;

        } else {
          ElMessage.error(response.msg)
        }
      } catch (error) {
        console.error('请求失败', error)
        ElMessage.error('请求失败，请重试')
      }
    }

    const addData = async () => {

      const dataParam = {
        'price': currentCarData.value.price,
        'name': currentCarData.value.name,
        'nameZh': currentCarData.value.nameZh,
        'description': currentCarData.value.description,
        'descriptionZh': currentCarData.value.descriptionZh,
        'serviceContent': currentCarData.value.serviceContent,
        'serviceContentZh': currentCarData.value.serviceContentZh,
        'leaveCityDescription': currentCarData.value.leaveCityDescription,
        'leaveCityDescriptionZh': currentCarData.value.leaveCityDescriptionZh,
        'yearNum': currentCarData.value.yearNum,
        'imagesId': currentCarData.value.imagesId,
        'shopId': shopId.value,
        'status': currentCarData.value.status,
      };

      if (currentCarData.value.id) {
        dataParam.id = currentCarData.value.id;
      }


      try {
        const response = await post('adminWeddingEmcee/addEmcee', dataParam)
        if (response.code === 200) {
          dialogFormVisible.value = false;
          ElMessage.success("保存成功");
          getData();
        } else {
          ElMessage.error(response.msg)
        }
      } catch (error) {
        console.error('请求失败', error)
        ElMessage.error('请求失败，请重试')
      }


    }



    const uploadFile = async (file) => {
      await upload('adminUpload/image', file, { 'type': 21 })
        .then(response => {

          if (response.code == 200) {

            imageArray.value.push(response.data);
            currentCarData.value.imagesId = imageArray.value.map(item => item.id).join(',');



          } else {
            ElMessage.error('上传失败，请重试')
          }

        })
        .catch(error => {
          console.error('请求失败', error)
          ElMessage.error('请求失败，请重试')
        });
    }

    const deleteData = async (id) => {
      await get('adminResourse/deleteResourse/' + id)
        .then(() => {
          ElMessage.success("删除成功");
          dialogVisible.value = false;

        })
        .catch(error => {
          ElMessage.error(error);
        });
    }

    const beforeUpload = (file) => {

      const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/webp'
      const isLt200KB = file.size / 1024 <= 200;

      if (!isImage) {
        ElMessage.error('请选择图片')
        return false;
      }

      if (!isLt200KB) {
        ElMessage.error('图片大小超过了200KB')
        return false;
      }

      uploadFile(file);
      return false; // 阻止默认上传行为
    }

    const deleteEmceeData = async (id) => {
      await get('adminWeddingEmcee/deleteEmcee/' + id)
        .then(() => {
          ElMessage.success("删除成功");
        })
        .catch(error => {
          ElMessage.error(error);
        });
    }

    const handleEdit = (item) => {
      // 打印或处理编辑数据
      currentCarData.value = item;
      imageArray.value = item.imageList;
      dialogFormVisible.value = true;
    };

    const onClickAddNewData = () => {

      currentCarData.value = {};
      imageArray.value = [];
      dialogFormVisible.value = true;

    }

    const onClickAddData = async (formEl) => {
      if (!formEl) return
      await formEl.validate((valid, fields) => {
        if (valid) {
          addData();
        } else {
          console.log('表单验证失败', fields)
          ElMessage.error('表单验证失败')
        }
      })
    }

    const removeImage1 = (index) => {
      if (imageArray.value[index] && imageArray.value[index].id) {
        deleteData(imageArray.value[index].id);
        imageArray.value.splice(index, 1);
        currentCarData.value.imagesId = imageArray.value.map(item => item.id).join(',');
      } else {
        console.error("该图片对象没有 id 属性！");
      }
    }

    const handleShowDeleteDialog = (row) => {
      currentCarData.value = row;
      dialogVisible.value = true;
    }

    const handleDelete = () => {
      deleteEmceeData(currentCarData.value.id);
    }

    const handleDescriptionChange = (val) => {
      currentCarData.value.description = val.replace(/\r?\n/g, '\n')
    }

    const handleDescriptionZhChange = (val) => {
      currentCarData.value.descriptionZh = val.replace(/\r?\n/g, '\n')
    }

    const handleServiceContentChange = (val) => {
      currentCarData.value.serviceContent = val.replace(/\r?\n/g, '\n')
    }

    const handleServiceContentZhChange = (val) => {
      currentCarData.value.serviceContentZh = val.replace(/\r?\n/g, '\n')
    }

    const handleLeaveCityDescriptionChange = (val) => {
      currentCarData.value.leaveCityDescription = val.replace(/\r?\n/g, '\n')
    }

    const handleLeaveCityDescriptionZhChange = (val) => {
      currentCarData.value.leaveCityDescriptionZh = val.replace(/\r?\n/g, '\n')
    }


    return {
      tableData,
      currentCarData,
      handleEdit,
      dialogFormVisible,
      imageArray,
      onClickAddData,
      onClickAddNewData,
      rules,
      ruleFormRef,
      removeImage1,
      beforeUpload,
      uploadFile,
      dialogVisible,
      handleShowDeleteDialog,
      handleDelete,
      dialogMuBan,
      handleDescriptionChange,
      handleDescriptionZhChange,
      handleServiceContentChange,
      handleServiceContentZhChange,
      handleLeaveCityDescriptionChange,
      handleLeaveCityDescriptionZhChange,
    }



  }
}
</script>

<style scoped>
.container {
  padding: 20px;
}

.topBox {
  display: flex;
  justify-content: space-between;

}

.imgBox {
  display: flex;
  align-items: center;
}

.imgBox img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  margin-right: 10px;
}

.avatar-container {
  display: flex;
  flex-wrap: wrap;
}

.avatar-box {
  position: relative;
  width: 80px;
  height: 80px;
  margin-right: 10px;
  border: 1px dashed #d9d9d9;

}

.avatar-box:hover {
  border-color: #409EFF;
}

.avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10%;
}

.delete-icon {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 20px;
  color: white;
}

.delete-icon:hover {
  color: #409EFF;
}

.uploader-icon {
  font-size: 25px;
  color: #8c939d;
  text-align: center;
  margin-top: 50%;
  transform: translate(0%, -50%);
}
</style>
